import { render } from "./PopularCountries.vue?vue&type=template&id=7d938b74"
import script from "./PopularCountries.vue?vue&type=script&lang=js"
export * from "./PopularCountries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__